<template>
  <div class="p-col-12">

    <public-header-component v-if="accessCode" title="forms.public-client.header-client-form" :accessCode="accessCode"/>

    <card class="p-col-12 p-md-10 p-lg-6" :header="$t('forms.public-client.people')" style="margin: auto;">
        <template v-for="(protocolClient, index) in protocolClients">
            <div :key="index" class="p-grid p-col-12 line-of-client">
                <div class="p-col-12 p-md-6 p-lg-6 text-vertical-center">
                    {{protocolClient.client.name}}
                </div>
                <div class="p-col-12 p-md-6 p-lg-6" style="min-width: fit-content;text-align: right;">
                    <a class="cursor-pointer" @click.prevent="editClient(protocolClient, index)"><i class="p-ml-4 pi pi-pencil small" :title="$t('protocol.tab-services.edit-client')"/></a>
                    <a class="cursor-pointer" @click.prevent="removeClient(protocolClient, index)"><i class="p-ml-4 pi pi-times small" :title="$t('protocol.tab-services.remove-client')"/></a>
                </div>
            </div>
            <template v-for="(protocolClientUnderage, indexUnderAgeClient) in protocolClientsUnderage" >
                <div v-if="protocolClientUnderage.client.id === protocolClient.client.id" :key="index+'underage'+indexUnderAgeClient" class="p-ml-auto p-grid p-col-10 line-of-client underage-line" style="margin-right: unset">
                    <div class="p-col-12 p-md-6 p-lg-6 text-vertical-center">
                        {{protocolClientUnderage.underAgeClient.name}}
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-6" style="min-width: fit-content;text-align: right;">
                        <a class="cursor-pointer" @click.prevent="editClientUnderage(protocolClientUnderage, indexUnderAgeClient)"><i class="p-ml-4 pi pi-pencil small" :title="$t('protocol.tab-services.edit-client')"/></a>
                        <a class="cursor-pointer" @click.prevent="removeClientUnderage(protocolClientUnderage, indexUnderAgeClient)"><i class="p-ml-4 pi pi-times small" :title="$t('protocol.tab-services.remove-client')"/></a>
                    </div>
                </div>
            </template>
        </template>
    </card>

    <form v-if="addingPerson" @submit.prevent="save">
        <card :header="$t('forms.client.card-personal-information')" class="p-col-12" >
          <coff-input-text v-model="form.name" label="forms.client.name" class="p-col-12 p-md-6 p-lg-4" :error="validation.name" />
          <coff-input-date v-model="form.birthDay" label="forms.client.birthDay" class="p-col-12 p-md-6 p-lg-4" :error="validation.birthDay" :max-date="new Date()" />
          <coff-input-date v-model="form.marriedDay" label="forms.client.marriedDay" class="p-col-12 p-md-6 p-lg-4" :min-date="form.birthDay" :max-date="new Date()" />
          <coff-input-select v-model="form.gender" label="forms.client.gender" class="p-col-12 p-md-6 p-lg-4" :options="genders" :translate="true" option-value="id"/>
          <coff-input-text v-model="form.document" label="forms.client.cpf" class="p-col-12 p-md-6 p-lg-4" :error="validation.document" mask="cpf"/>
          <coff-input-text v-model="form.rg" label="forms.client.rg" class="p-col-12 p-md-6 p-lg-4" mask="rg"/>
          <coff-input-select v-model="form.maritalStatus" label="forms.client.maritalStatus" class="p-col-12 p-md-6 p-lg-4" :options="maritalStatusList" :translate="true" option-value="id" :error="validation.maritalStatus"/>
        </card>

        <card :header="$t('forms.client.card-relationship')" class="p-col-12" >
          <coff-input-text v-model="form.motherName" label="forms.client.mother" class="p-col-12 p-md-6 p-lg-6" field="name"/>
          <coff-input-text v-model="form.fatherName" label="forms.client.father" class="p-col-12 p-md-6 p-lg-6" field="name"/>
          <coff-input-text v-model="form.spousesName" label="forms.client.spouse" class="p-col-10 p-md-6 p-lg-6"/>
        </card>

        <card :header="$t('forms.client.card-contact-information')" class="p-col-12" >
          <coff-input-text v-model="form.phoneNumber" label="forms.client.phoneNumber" class="p-col-12 p-md-6 p-lg-4" mask="phone"/>
          <coff-input-text v-model="form.cellPhoneNumber" label="forms.client.cellPhoneNumber" class="p-col-12 p-md-6 p-lg-4" mask="cellPhone"/>
          <coff-input-email v-model="form.email" ref="email" label="forms.client.email" class="p-col-12 p-md-6 p-lg-4" :error="validation.email"/>
        </card>

        <card :header="$t('forms.address.card-information')" class="p-col-12" >
          <coff-input-select v-model="form.address.country" label="forms.address.country" class="p-col-12 p-md-6 p-lg-4" :options="countries" :translate="true" option-value="id" option-label="country"/>
          <coff-input-text v-model="form.address.zipCode" label="forms.address.zipCode" class="p-col-12 p-md-6 p-lg-4" mask="zipcode" />
          <coff-input-select v-model="form.address.state" label="forms.address.state" class="p-col-12 p-md-6 p-lg-4" :options="states" :translate="true" option-value="id" v-if="form.address.country === 'BRASIL'"/>
          <coff-input-text v-model="form.address.foreignState" label="forms.address.state" class="p-col-12 p-md-6 p-lg-4" v-else/>
          <coff-input-text v-model="form.address.city" label="forms.address.city" class="p-col-12 p-md-6 p-lg-4" />
          <coff-input-text v-model="form.address.district" label="forms.address.district" class="p-col-12 p-md-6 p-lg-4" />
          <coff-input-text v-model="form.address.street" label="forms.address.street" class="p-col-12 p-md-6 p-lg-4" />
          <coff-input-text v-model="form.address.number" label="forms.address.number" class="p-col-12 p-md-6 p-lg-4" />
          <coff-input-text v-model="form.address.complement" label="forms.address.complement" class="p-col-12 p-md-6 p-lg-4" />
        </card>

        <div class="p-col-12 save-button">
          <Button :label="$t('btn.cancel')" class="float-left p-button-outlined p-button-secondary p-mr-2" @click.prevent="cleanForm"/>
          <Button :label="$t('btn.save&continue')" class="p-button-success"/>
        </div>
  </form>
    <div class="p-col-12" style="text-align: center" v-else>
      <Button v-if="protocolClients.length > 0" class="p-col-12 p-md-12 p-lg-2 p-button-outlined p-button-success p-mr-2 p-mb-2 p-button p-component" @click.prevent="finalizeInformation">
            <span class="p-button-label">
              <i class="fas fa-check p-mr-2"></i>{{$t('forms.public-client.finalize')}}
            </span>
      </Button>
      <Button class="p-col-12 p-md-12 p-lg-2 p-button-outlined p-mr-2 p-mb-2 p-button p-component" @click.prevent="toggleAddPerson(false)">
            <span class="p-button-label">
              <i class="pi pi-plus p-mr-2"></i>{{$t('forms.public-client.add-person')}}
            </span>
      </Button>
      <Button class="p-col-12 p-md-12 p-lg-2 p-button-outlined p-button-help p-mr-2 p-mb-2 p-button p-component" @click.prevent="initAddUnderage">
          <span class="p-button-label">
            <i class="pi pi-plus p-mr-2"></i>{{$t('forms.public-client.add-underage')}}
          </span>
      </Button>
    </div>
  </div>
</template>

<script>

import ValidationUtils from "@/utils/ValidationUtils";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import EventBus from "@/commons/EventBus";
import ClientBusiness from "@/business/ClientBusiness";
import AddressBusiness from "@/business/AddressBusiness";
import CountryBusiness from "@/business/CountryBusiness";
import Utils from "@/utils/Utils";
import DialogService from "@/business/ModalBusiness";
import ModalCodeAccess from "@/viewer/public-client-form/ModalCodeAccess";
import PublicClientBusiness from "@/business/PublicClientBusiness";
import PublicAncestrylineConfirmation from "@/components/dialog/PublicAncestrylineConfirmation";
import ModalGetResponsible from "@/viewer/public-client-form/ModalGetResponsible.vue";
import ModalClientNotification from "@/viewer/public-client-form/ModalClientNotification.vue";
import PublicHeaderComponent from "@/viewer/public-client-form/PublicHeaderComponent.vue";
import DateUtils from "@/utils/DateUtils";

export default {
  name: "PublicClientForm",
  components: {PublicHeaderComponent},

  data(){
    return {
      form: {
        address: {},
        typeOfPerson: 'PERSON',
      },
      validation: {
        name: false,
      },
      options: [
        {value: true, label: 'field.default.yes'},
        {value: false, label: 'field.default.no'}
      ],
      maritalStatusList: ClientBusiness.getMaritalStatus(),
      genders: ClientBusiness.getGenders(),
      states: AddressBusiness.getStates(),
      countries: CountryBusiness.getCountries(),
      accessCode: null,
      protocolId: null,
      protocolClients: [],
      protocolClientsUnderage: [],
      editingIndex: null,
      addingPerson: false,
      editingAddingUnderage: false,
    }
  },
  async mounted(){
    this.protocolId = this.$route?.params?.protocolId;
    if(this.protocolId){
      EventBus.loadingPage(true);
      this.accessCode = localStorage.getItem('accessCode');
      if(Utils.isEmptyNullOrUndefined(this.accessCode)) {
        await this.getAccessCode();
      } else {
        await this.loadClientsProtocol();
      }
      EventBus.loadingPage(false);
    }
  },
  methods:{

    async toggleAddPerson(addingUnderage){
      this.addingPerson = !this.addingPerson;
      this.editingAddingUnderage = addingUnderage;
    },

    async initAddUnderage(){
        const clientResponsible = await DialogService.openModal(ModalGetResponsible, {clients: this.protocolClients.map(pc => pc.client)});
        if(clientResponsible){
            this.form.responsible = clientResponsible;
            await this.toggleAddPerson(true);
        }
    },

    async finalizeInformation(){
      const message = await DialogService.openModal(ModalClientNotification);
      if(message || message === ""){
          if(await DialogService.openConfirmationModal(PublicAncestrylineConfirmation)){
              const response = await PublicClientBusiness.sendNotification(message, this.protocolId, this.accessCode).catch((e) => ToastMessageBusiness.showError(e.message));
              if(response){
                  ToastMessageBusiness.showSuccess('forms.public-client.information-send');
              }
          }
      }
    },

    async loadClientsProtocol(){
      const protocolClients = await PublicClientBusiness.getAll(this.protocolId, this.accessCode).catch(async (e) => {
        ToastMessageBusiness.showError(e.message);
        this.accessCode = null;
        localStorage.removeItem('accessCode');
        await this.getAccessCode();
      });
      if(protocolClients){
          this.protocolClients = protocolClients;
          this.protocolClientsUnderage = await PublicClientBusiness.getProtocolTypeServicesWithUnderAge(this.protocolId, this.accessCode).catch(async () => {
              this.accessCode = null;
              localStorage.removeItem('accessCode');
              await this.getAccessCode();
          });
      }
    },

    async getAccessCode(){
      this.accessCode = await DialogService.openModal(ModalCodeAccess);
      if(Utils.isEmptyNullOrUndefined(this.accessCode)){
        await this.getAccessCode();
      }
      localStorage.setItem('accessCode', this.accessCode);
      await this.loadClientsProtocol();
    },

    editClient(clientProtocol, index){
      this.toggleAddPerson(false);
      this.editingIndex = index;
      if(!clientProtocol.client.address){
        clientProtocol.client.address = {};
      }
      if(clientProtocol.client.birthDay){
        clientProtocol.client.birthDay = DateUtils.toStringDate(clientProtocol.client.birthDay);
      }
      if(clientProtocol.client.marriedDay){
        clientProtocol.client.marriedDay = DateUtils.toStringDate(clientProtocol.client.marriedDay);
      }
      this.form = clientProtocol.client;
    },

    async removeClient(protocolClient, index){
      this.cleanForm();
      if(await DialogService.openConfirmationModal(PublicAncestrylineConfirmation)){
        const response = await PublicClientBusiness.delete(protocolClient.id, this.protocolId, this.accessCode).catch((e) => ToastMessageBusiness.showError(e.message));
        if(response){
          this.protocolClients.splice(index, 1);
          ToastMessageBusiness.showSuccess();
        }
      }
    },

    async removeClientUnderage(protocolClient, index){
        this.cleanForm();
        if(await DialogService.openConfirmationModal(PublicAncestrylineConfirmation)){
            const response = await PublicClientBusiness.deleteProtocolTypeService(protocolClient.id, this.protocolId, this.accessCode).catch((e) => ToastMessageBusiness.showError(e.message));
            if(response){
                this.protocolClientsUnderage.splice(index, 1);
                ToastMessageBusiness.showSuccess();
            }
        }
    },

    editClientUnderage(clientProtocol, index){
        this.toggleAddPerson(true);
        this.editingIndex = index;
        if(!clientProtocol.underAgeClient.address){
            clientProtocol.underAgeClient.address = {};
        }
        if(clientProtocol.underAgeClient.birthDay){
            clientProtocol.underAgeClient.birthDay = DateUtils.toStringDate(clientProtocol.underAgeClient.birthDay);
        }
        if(clientProtocol.underAgeClient.marriedDay){
            clientProtocol.underAgeClient.marriedDay = DateUtils.toStringDate(clientProtocol.underAgeClient.marriedDay);
        }
        this.form = clientProtocol.underAgeClient;
    },

    async save(){
      this.validation = ValidationUtils.basicValidation(this.validation, this.form);
      this.validation.erros = this.$refs.email.emailValidation(this.validation.erros);
      if(!this.validation.erros){
        if(this.form.id){
          await this.edit();
        } else {
          await this.add();
        }
      }
    },

    async edit(){
      const response = await PublicClientBusiness.edit(this.form, this.form.id, this.protocolId, this.accessCode).catch((e) => ToastMessageBusiness.showError(e.message));
      if(response){
        if(this.editingAddingUnderage){
          this.protocolClientsUnderage[this.editingIndex].underAgeClient = response;
        } else {
          this.protocolClients[this.editingIndex].client = response;
        }
        this.editingIndex = null;
        this.cleanForm();
        ToastMessageBusiness.showSuccess();
        EventBus.$emit('client_saved', response);
      }
    },

    async add(){
      const response = await PublicClientBusiness.save(this.form, this.protocolId, this.accessCode).catch((e) => ToastMessageBusiness.showError(e.message));
      if(response){
        if(this.editingAddingUnderage){
            this.protocolClientsUnderage.push(response);
        } else {
            this.protocolClients.push(response);
        }
        this.cleanForm();
        ToastMessageBusiness.showSuccess();
        EventBus.$emit('client_saved', response);
      }
    },

    cleanForm(){
      this.toggleAddPerson(false);
      this.form = {
        address: {},
        typeOfPerson: 'PERSON',
      };
    },

  }
}
</script>

<style scoped>

.line-of-client {
  border-radius: 3px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5px;
  background-color: #d7dbe8;
}

.cursor-pointer {
  cursor: pointer;
}

.public-header {
  background-color: white;
  margin-left: 0;
}

.personal-infos {
  margin-top: auto;
  margin-bottom: auto;
}

.contact-infos{
  margin-top: auto;
  margin-bottom: auto;
  text-align: end;
}

h1 {
  font-size: xx-large;
}

.save-button{
  text-align: center;
  margin-bottom: 8px;
}

.underage-line{
    border-left-width: initial;
    border-left-color: #d2ac71;
    border-left-style: solid;
}

</style>